import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAIMatching = lazy(() => import("@/pages/admin/AdminAIMatching"));

export const Route = createFileRoute("/admin/ai-matching")({
  component: AdminAIMatching,
});
